import React from 'react';
import './Home.css';
import { NavLink } from 'react-router-dom';
import m5 from '../../Assets/311.avif'

function StepOne() {
  const services = [{
    _id: 1,
    name: '“Education is the movement from darkness to light.” – Allan Bloom',
    
  },
  {
    _id: 2,
    name: '“Change is the end result of all true learning.” – Leo Buscaglia',
    
  },
  {
    _id: 3,
    name: '“Either you run the day or the day runs you.” – Jim Rohn',
    
   
  },
  {
    _id: 4,
    name: '“Every artist was at first an amateur.” – Ralph W. Emerson',
   
  },
  ]
  return (
    <>
     <h1 className="text-2xl lg:text-6xl px-0 lg:px-24  mt-12 mb-3 text-center lg:mb-[-50px]">“Nine-tenths of education is encouragement.”– Anatole France</h1>
    
    
   
    <div className="hero min-h-screen"> 
       <div className="hero-content flex-col lg:flex-row-reverse">
       <img src={m5} className="h-80" style={{borderRadius:'5px'}} alt="LifeLong365Image"/>
      <div>
      <div>
        <p className='pt-3' style={{fontSize:'25px',fontWeight:'700',fontFamily:'raleway', color:'tomato'}}>Lifelong365! <span style={{color:'#0096FF',fontSize:'19px'}}>What Is Our Motto?</span></p>
        <p className='pt-3' style={{fontSize:'15px',fontWeight:'400',fontFamily:'raleway'}}>Education is Number One! <br/>In today's rapidly changing world, learning is no longer confined to the traditional classroom setting. With the advent of<span style={{fontWeight:'600',fontSize:'15px'}}> technology, </span>learning has become more accessible than ever before, with a plethora of education apps available to anyone with a smartphone, tablet and computer.</p>
        <p className='pt-3' style={{fontSize:'15px',fontWeight:'400',fontFamily:'raleway'}}>Lifelong365 offer a range of benefits, <span style={{fontWeight:'600',fontSize:'15px'}}>School - University(BD Based)</span> and  <span style={{fontWeight:'600',fontSize:'15px'}}>[Certificate and Career(JP Based)]</span>. At the heart of every education app lies a motto, a guiding principle that underpins the app's philosophy and approach to learning. </p>
        <p className='pt-3' style={{fontSize:'15px',fontWeight:'400',fontFamily:'raleway'}}>Our motto is <span style={{fontWeight:'600',fontSize:'15px'}}>"Empowering Lifelong Learners."</span> Empowering Lifelong Learners is a motto that reflects a commitment to providing users with the tools and resources they need to become active,  <span style={{fontWeight:'600',fontSize:'15px'}}>engaged learners</span> who are motivated to continue learning long after they leave school. </p>
        <p className='pt-3' style={{fontSize:'15px',fontWeight:'400',fontFamily:'raleway'}}>For example, the app could provide information directly related with our learning, career track. By getting latest information about <span style={{fontWeight:'600',fontSize:'15px'}}> latest certificate exam</span>, <span style={{fontWeight:'600',fontSize:'15px'}}> career essential hacks</span>, <span style={{fontWeight:'600',fontSize:'15px'}}> educational institution information</span> the app can help users stay engaged and motivated, which is essential for long-term learning.</p>
       
    </div>

    </div>
  </div>
</div>





          <div  className="bigBox grid sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4  gap-5 px-5 py-5">
          
          {services.map(service => 
                <div className="boxContainer card lg:card-side bg-base-100 shadow-xl" key={service._id}>
                    <div className="">
                      <h2 style={{fontFamily:'raleway'}} className="text-center text-md pl-3 pr-2 py-3">{service.name}</h2>
                     </div>
                </div>
              )
           }


      
    </div>




</>
  )
}

export default StepOne